import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import map from 'lodash/map';

// components
import PreviewTemplate1 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate1';
import PreviewTemplate2 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate2';
import PreviewTemplate3 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate3';
import PreviewTemplate4 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate4';
import PreviewTemplate5 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate5';
import PreviewTemplate6 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate6';
import PreviewTemplate7 from 'pages/MerchantPages/Assets/PreviewTemplates/PreviewTemplate7';
import { AnalyticsComponent } from '@inplayer-org/inplayer-ui';

const TemplatesContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 2rem;
  justify-items: center;

  @media screen and (max-width: 1450px) {
    grid-template-columns: repeat(3, 1fr);
  }

  @media screen and (max-width: 1100px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const previews = {
  1: PreviewTemplate1,
  2: PreviewTemplate2,
  3: PreviewTemplate3,
  4: PreviewTemplate4,
  5: PreviewTemplate5,
  6: PreviewTemplate6,
  7: PreviewTemplate7,
};

interface OwnProps {
  handlePreviewChange: (id: number) => void;
  previewTemplateId: number | null;
}

const PreviewTemplateBox: FunctionComponent<OwnProps> = ({ handlePreviewChange, previewTemplateId }) => {
  return (
    <AnalyticsComponent>
      {({ pages, tracker, merchantId, ip }) => (
        <TemplatesContainer>
          {map(previews, (PreviewTemplate, key) => {
            return (
              <PreviewTemplate
                key={key}
                id={Number(key)}
                onBodyClick={(id) => {
                  tracker.track({
                    event: 'click',
                    type: 'box',
                    tag: `preview_box_${key}`,
                    pages,
                    merchantId,
                    ip,
                  });
                  handlePreviewChange(id);
                }}
                isTemplateSelected={previewTemplateId === Number(key)}
              />
            );
          })}
        </TemplatesContainer>
      )}
    </AnalyticsComponent>
  );
};

export default PreviewTemplateBox;
